import * as Yup from 'yup'

var schema = Yup.object().shape({
	user: Yup.object().required('Nama lengkap tidak boleh kosong.'),
	category: Yup.object().required('Kategori tidak boleh kosong.'),
})

export default schema
